/**
 * 物流管理API服务
 */

import axios from 'axios';
import type { ShippingChannel, ShippingRateTier, ShippingCostCalculation } from '../types/shipping-types';

const API_BASE_URL = '/api';

/**
 * 物流渠道查询参数
 */
export interface GetChannelsParams {
    destination?: string;
    shipping_method?: string;
    is_active?: string | boolean;
}

/**
 * 运费阶梯查询参数
 */
export interface GetRateTiersParams {
    channel?: number;
}

/**
 * 运费趋势查询参数
 */
export interface RateTrendsParams {
    destination?: string;
    months?: number;
    weight_range?: string;
}

/**
 * 趋势数据点
 */
export interface RateTrendDataPoint {
    date: string;
    price_per_kg: number;
}

/**
 * 渠道趋势数据
 */
export interface RateTrendChannel {
    channel_id: number;
    channel_name: string;
    shipping_method: string;
    transit_days: number;
    data: RateTrendDataPoint[];
}

/**
 * 运费趋势响应
 */
export interface RateTrendsResponse {
    destination: string;
    weight_range: string;
    period_months: number;
    start_date: string;
    end_date: string;
    trends: RateTrendChannel[];
}

export const shippingAPI = {
    // 物流渠道
    getChannels: (params?: GetChannelsParams) =>
        axios.get<ShippingChannel[]>(`${API_BASE_URL}/shipping-channels/`, { params }),

    getChannel: (id: number) =>
        axios.get<ShippingChannel>(`${API_BASE_URL}/shipping-channels/${id}/`),

    createChannel: (data: Partial<ShippingChannel>) =>
        axios.post<ShippingChannel>(`${API_BASE_URL}/shipping-channels/`, data),

    updateChannel: (id: number, data: Partial<ShippingChannel>) =>
        axios.put<ShippingChannel>(`${API_BASE_URL}/shipping-channels/${id}/`, data),

    deleteChannel: (id: number) =>
        axios.delete(`${API_BASE_URL}/shipping-channels/${id}/`),

    calculateCost: (channelId: number, weight_kg: number) =>
        axios.post<ShippingCostCalculation>(`${API_BASE_URL}/shipping-channels/${channelId}/calculate_cost/`, { weight_kg }),

    // 运费趋势
    getRateTrends: (params?: RateTrendsParams) =>
        axios.get<RateTrendsResponse>(`${API_BASE_URL}/shipping-channels/rate_trends/`, { params }),

    // 运费阶梯
    getRateTiers: (params?: GetRateTiersParams) =>
        axios.get<ShippingRateTier[]>(`${API_BASE_URL}/shipping-rates/`, { params }),

    createRateTier: (data: Partial<ShippingRateTier>) =>
        axios.post<ShippingRateTier>(`${API_BASE_URL}/shipping-rates/`, data),

    updateRateTier: (id: number, data: Partial<ShippingRateTier>) =>
        axios.put<ShippingRateTier>(`${API_BASE_URL}/shipping-rates/${id}/`, data),

    deleteRateTier: (id: number) =>
        axios.delete(`${API_BASE_URL}/shipping-rates/${id}/`),
};
